import { render, staticRenderFns } from "./OfficeInsurance.vue?vue&type=template&id=3a6d875b"
import script from "./OfficeInsurance.vue?vue&type=script&lang=js"
export * from "./OfficeInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports